import classnames from 'classnames/bind';
import style from './index.module.scss';
import CommonPop from '../CommonPop';
import Common from '../../Common/Common';
import { 
    PayPalButtons,
    PayPalCardFieldsForm,
    PayPalCardFieldsProvider,
    PayPalScriptProvider,
    ReactPayPalScriptOptions} from '@paypal/react-paypal-js';
import { PaypalCom } from '../../Api/PaypalCommon';
import { Address, PayPalCancelProto, PayPalCaptureProto, PayPalPayProto, cartdata } from '../../Net/NetProtocol';
import NoData from '../../components/NoData';
import ShowImge from '../ShowImge';
import { useMemo, useState } from 'react';
import { pushFbEvent } from '../../Api/FbEven';
import SubmitPayment from './SubmitPayment';
import { DiscountCfg } from '../../Common/ShopCardData';
const className = classnames.bind(style);

const initialOptions:ReactPayPalScriptOptions = {
    clientId: process.env.PAYPAL_CLIENT_ID||"",
    enableFunding: "venmo",
    components: "buttons,card-fields",
};

const ShoppingCard = ()=>{
    const [ImageUrl, SetImageUrl] = useState("");
    const [SelectAd, SetSelectAd] = useState(0);
    const [isShowCardPay, setIsShowCardPay] = useState(false);
    const ShowPidImage = (pid:string, imgid:number)=>{
        SetImageUrl(GetImgUrlById(pid, imgid));
    }
    const shopcard = Common.ShopCard;
    const NRouter = Common.Common.NRouter;
    const closeFunc = ()=>{
        shopcard.IsShow = false;
    }
    const showDiscount = ()=>{
        Common.Common.ShowReward = true;
    }
    const GetImgUrlById = (pid:string, imgid:number)=>{
        return "/product/product/" + pid + "/" + imgid + ".jpg";
    }

    const showProduct = (pid:string)=>{
        shopcard.IsShow = false;
        NRouter?.('/Product/'+pid);
    }

    const saddress = useMemo(()=>{
        let addr:Address|null = null;
        const userinfo = Common.UserData;
        if(userinfo.address && userinfo.address[SelectAd]){
            addr = userinfo.address[SelectAd];
        }
        return addr;
    },[SelectAd, Common.UserData.SelectAd]);

    const totalprice = useMemo(()=>{
        if(shopcard.Products.length > 0){
            let aprice = 0;
            let discou = 0;
            let allAmount = 0;
            let rprice = 0;
            for (let index = 0; index < shopcard.Products.length; index++) {
                const element = shopcard.Products[index];
                aprice += Math.round(element.Price * element.Amount * 100)/100;
                allAmount += element.Amount;
            }
            for (let index = 0; index < DiscountCfg.length; index++) {
                let value = DiscountCfg[index];
                if(allAmount >= value[0]){
                    discou = value[1];
                    break;
                }
            }
            if(discou > 0){
                rprice = Math.round(aprice*(100-discou))/100;
            }
            else{
                rprice = aprice;
            }
            return {allprice: aprice, discount:discou, realprice:rprice };
        }
        return null;
    }, [shopcard, shopcard.Products]);

    const createOrder = async ()=> {
        const userinfo = Common.UserData;
        if(!userinfo){
            Common.Common.ShowLogin = true;
        }
        else if(totalprice){
            let ndata: PayPalPayProto = new PayPalPayProto();
            ndata.account = Common.UserData.account;
            ndata.description = "";
            ndata.price = totalprice.allprice;
            ndata.discount = totalprice.allprice-totalprice.realprice;
            ndata.items = shopcard.Products;
            if(SelectAd >= 0 && userinfo.address && userinfo.address[SelectAd]){
                ndata.address = userinfo.address[SelectAd];
            }
            else{
                Common.UserData = {SelectAd:0};
                return "";
            }
            let orderid = await PaypalCom.MyCreateOrder(ndata);
            return orderid;
        }
    }
    
    const onApprove = async (data:any)=> {
        const userinfo = Common.UserData;
        let ndata: PayPalCaptureProto = new PayPalCaptureProto();
        ndata.account = userinfo.account;
        ndata.orderid = data.orderID;
        const {orderid, status, timed} = await PaypalCom.MyCaptureOrder(ndata);
        if(orderid && PaypalCom.GetStatus(status)===PaypalCom.orderstatus.COMPLETED){
            Common.Common.PopTips = "Payment successful";
            if(timed && timed > 0){
                if(!userinfo.products){
                    userinfo.products = [timed];
                }
                else{
                    userinfo.products.push(timed);
                }
            }
            let Price = 0;
            let pcontents = [];
            for (let index = 0; index < shopcard.Products.length; index++) {
                const element = shopcard.Products[index];
                Price += Math.round(element.Price * element.Amount * 100)/100;
                pcontents.push({id:element.ProductId,quantity: element.Amount});
            }
            pushFbEvent("Purchase",{
                contents:pcontents,
                content_type:"product",
                currency:"USD",
                value:Price
            })
            shopcard.Clear();
            shopcard.IsShow = false;
            Common.Orders.IsShow = true;
        }
        else{
            Common.Common.PopTips = "Payment successful";
        }
    }

    //订单取消
    const onCancel = (data:any)=> {
        const userinfo = Common.UserData;
        if(userinfo){
            let ndata: PayPalCancelProto = new PayPalCancelProto();
            ndata.account = userinfo.account;
            ndata.orderid = data.orderID;
            PaypalCom.CanCelOrder(ndata);
        }
    }

    //订单出错
    const onError = ()=>{
        console.log("===========>>>>创建订单出错!");
        Common.Common.ShowLoading = false;
    }

    const subname = (namestr: string):string=>{
        if(namestr.length > 22){
            return namestr.substring(0, 22)+"..."
        }
        return namestr;
    }

    const onModify = ()=>{
        Common.UserData = {SelectAd:SelectAd+1};
    }

    const onAddNew = ()=>{
        Common.UserData = {SelectAd:0};
    }

    const onAddressChange = (selectop:any)=>{
        let selectad:number = Number.parseInt(selectop.value);
        SetSelectAd(selectad);
    }

    const ClearShopcard = ()=>{
        shopcard.Clear();
    }

    return(
        <>
        <CommonPop closeWindown={closeFunc}>
            <div className={className('contentbox')}>
                <div className={className('Clear')}>
                    <div className={className('Discount')} onClick={showDiscount}>Up to 25% off</div>
                    {shopcard.Products.length > 0 &&<button onClick={ClearShopcard}>Clear</button>}
                </div>
            <div className={className('address')}>
                {
                    saddress?
                    <div>
                        Address:
                        <select name="Address" id="SelectAddress" onChange={e => onAddressChange(e.target)}>
                          {
                            Common.UserData.address.map((value: Address, index: number)=>{
                                return(
                                    <option key={index} value={index}>{`${index+1}. ${value.fullname} ${value.areacode+ value.phonenum}`}</option>
                                )
                            })
                          }
                        </select>
                        <button onClick={onModify}>Modify</button>
                    </div>:
                    <div>
                        <button onClick={onAddNew}>Add New Address</button>
                    </div>
                }
            </div>
            <section className={className('datalist')}>
            <div className={className('item')}>
            {
                shopcard.Products.length > 0?
                shopcard.Products.map((item:cartdata,index:number)=>{
                    return(
                        <div className={className('itembox')} key={"p"+index}>
                            <div className={className('picture')}>
                                <img src={GetImgUrlById(item.ProductId, item.ImgeId)} onClick={()=>ShowPidImage(item.ProductId, item.ImgeId)} alt={item.ProductId}/>
                            </div>
                            <div className={className('details')}>
                                <div className={className('itemdiv')} >
                                    <div className={className('title')}>{"No.:"}<span>{subname(item.ProductId)}</span></div>
                                    <div className={className('title')}>{"types:"}<span>{item.Names}</span></div>
                                </div>
                                <div className={className('itemdiv')} >
                                    <div className={className('title')}>{"amount:"}<span>{item.Amount}</span></div>
                                    <div className={className('title')}>{"price:"}<span>{"$"+(Math.round(item.Amount*item.Price*100)/100).toString()}</span></div>
                                </div>
                            </div>
                            
                            <div className={className('buttonprent')}>
                                <div className={className('clsbutton')}>
                                    <button onClick={()=>{shopcard.RemoveData(item)}}>X</button>
                                </div>
                                <div className={className('gobutton')}>
                                    <button onClick={()=>{showProduct(item.ProductId)}}>details</button>
                                </div>
                            </div>
                        </div>
                    )
                }):
                <NoData />
            }
            </div>
            </section>
            {totalprice !== null &&
            <div className={className('paybutton')}>
                    <>
                    <div style={{color:"#fc9c00", fontSize:"20px", fontWeight:"bold", flexDirection:"row", display:"flex"}}>
                        Total price:<div style={{color:"#4373ed", textDecoration:totalprice.discount > 0?"line-through":"none"}}>{" $"+totalprice.allprice}</div>
                        {totalprice.discount > 0 && <div style={{color:"#00166e", fontSize:"20px"}}>
                          &nbsp; {` $${totalprice.realprice} (${totalprice.discount}%off)`}
                        </div>}
                    </div>
                    <div style={{cursor:"pointer"}} onClick={()=>{setIsShowCardPay(!isShowCardPay)}}>
                        <input 
                          type="checkbox" 
                          checked={isShowCardPay}
                          onChange={()=>{setIsShowCardPay(!isShowCardPay)}}
                          style={{ width:"25px", height:"25px" }}
                        />
                        <label style={{fontSize: "18px", color:"black", height:"25px", lineHeight:"25px", textAlign:"center" }}>
                            Pay with bank card or visa
                        </label>
                    </div>
                    <PayPalScriptProvider options={initialOptions}>
                        {isShowCardPay?
                            <PayPalCardFieldsProvider
                                createOrder={createOrder}
                                onApprove={onApprove}
                                onError={onError}
                                style={{
                                    input: {
                                        "font-size": "16px",
                                        "font-family": "courier, monospace",
                                        "font-weight": "lighter",
                                        color: "#ccc",
                                    },
                                    ".invalid": { color: "purple" }
                                }}
                            >
                                <PayPalCardFieldsForm/>
                                <SubmitPayment/>
                            </PayPalCardFieldsProvider>
                            :
                            <PayPalButtons
                                createOrder={createOrder}
                                onApprove={onApprove}
                                onCancel={onCancel}
                                onError={onError}
                                style={{
                                    shape: "rect",
                                    layout: "vertical",
                                    color: "gold",
                                    label: "paypal"
                                }}
                            />
                        }
                    </PayPalScriptProvider>
                    </>
            </div>
            }
            </div>
        </CommonPop>
        {
            ImageUrl !== "" &&<ShowImge ImageUrl={ImageUrl} CloseImg={()=>{SetImageUrl("")}}></ShowImge>
        }
        </>
    )
}

export default ShoppingCard;